export const mainMenu = () => {
  const toggleMenu = document.getElementById("toggleMenu");
  const toggleNavigation = document.getElementById("toggleNavigation");
  const navigation = document.getElementById("navigation");
  const navbarLogo = document.querySelector(".navbar__logo");
  const navbar = document.querySelector(".navbar");
  const body = document.body;
  const html = document.documentElement;
  const header = document.getElementById("header");

  // Must match $transition-speed in scss/variables/transitions.scss
  const MENU_SLIDE_MS = 300;
  let closingTimer;

  const isDesktop = () => window.matchMedia("(min-width: 1024px)").matches;
  const isSmallScreen = () => window.matchMedia("(max-width: 576px)").matches;

  const addClasses = () => {
    clearTimeout(closingTimer);
    if (header) header.classList.remove("menuIsClosing");
    navigation.classList.add("isActive");
    navbarLogo.classList.add("showSymbol");

    if (!isDesktop()) {
      toggleMenu.classList.add("active");
    }

    body.classList.add("menuIsOpen");
    if (header) {
      header.classList.add("menuIsOpen");
    }

    if (body.classList.contains("home") && isSmallScreen() && navbar) {
      if (navbar.classList.contains("isLight")) {
        navbar.classList.remove("isLight");
        navbar.classList.add("isDark");
      }
    }
  };

  const removeClasses = () => {
    navigation.classList.remove("isActive");
    navbarLogo.classList.remove("showSymbol");

    if (!isDesktop()) {
      toggleMenu.classList.remove("active");
    }

    body.classList.remove("menuIsOpen");
    if (header) {
      header.classList.remove("menuIsOpen");
      // A CSS delay cannot keep .menuIsOpen alive: dropping the class stops its
      // rules at once, the header regains its backdrop-filter and so becomes the
      // containing block of the still sliding .navigation, which then jumps to the
      // header's -56px. This class holds that neutralisation until the slide ends.
      header.classList.add("menuIsClosing");
      clearTimeout(closingTimer);
      closingTimer = setTimeout(() => {
        header.classList.remove("menuIsClosing");
      }, MENU_SLIDE_MS);
    }

    if (body.classList.contains("home") && isSmallScreen() && navbar) {
      if (navbar.classList.contains("isDark")) {
        navbar.classList.remove("isDark");
        navbar.classList.add("isLight");
      }
    }
  };

  const handleClickOutside = (event) => {
    if (
      !navigation.contains(event.target) &&
      !toggleMenu.contains(event.target)
    ) {
      removeClasses();
      document.removeEventListener("click", handleClickOutside);
    }
  };

  if (toggleNavigation && toggleMenu && navigation && navbarLogo) {
    toggleNavigation.addEventListener("mouseenter", () => {
      if (isDesktop()) addClasses();
    });

    toggleNavigation.addEventListener("mouseleave", (event) => {
      if (isDesktop() && !navigation.contains(event.relatedTarget)) {
        removeClasses();
      }
    });

    navigation.addEventListener("mouseenter", () => {
      if (isDesktop()) addClasses();
    });

    navigation.addEventListener("mouseleave", (event) => {
      if (isDesktop() && !toggleNavigation.contains(event.relatedTarget)) {
        removeClasses();
      }
    });

    toggleMenu.addEventListener("click", () => {
      if (!isDesktop()) {
        if (toggleMenu.classList.contains("active")) {
          removeClasses();
          document.removeEventListener("click", handleClickOutside);
        } else {
          addClasses();
          setTimeout(() => {
            document.addEventListener("click", handleClickOutside);
          }, 0);
        }
      }
    });

    const primaryMenuLinks = Array.from(
      navigation.querySelectorAll("ul#primary-menu li a")
    );

    toggleNavigation.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        if (!navigation.classList.contains("isActive")) {
          addClasses();
          if (primaryMenuLinks.length > 0) {
            primaryMenuLinks[0].focus();
          }
        } else {
          removeClasses();
          toggleNavigation.focus();
        }
      }
    });

    navigation.addEventListener("keydown", (event) => {
      const { key, shiftKey } = event;
      const activeElement = document.activeElement;
      const firstLink = primaryMenuLinks[0];
      const lastLink = primaryMenuLinks[primaryMenuLinks.length - 1];

      if (key === "Escape") {
        event.preventDefault();
        removeClasses();
        toggleNavigation.focus();
      }

      if (key === "Tab") {
        if (!shiftKey && activeElement === lastLink) {
          event.preventDefault();
          removeClasses();
          toggleNavigation.focus();
        } else if (shiftKey && activeElement === firstLink) {
          event.preventDefault();
          removeClasses();
          toggleNavigation.focus();
        }
      }
    });
  }

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (isDesktop()) {
        document.removeEventListener("click", handleClickOutside);
        removeClasses();
      }
    }, 150);
  });
};
